var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// ../internal/src/providers/attachment-provider/attachment-provider.tsx
import React4 from "react";

// ../internal/src/hooks/use-authentication-config.tsx
import React2 from "react";
import { useProvidedState } from "@shared-ui/provided-state-context";

// ../internal/src/providers/vac-id/vac-id-provider.tsx
import React, { useState } from "react";
import { v4 as uuid } from "uuid";
var VacIdContext = React.createContext(void 0);
var VacIdProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */React.createElement(VacIdContext.Provider, {
    value
  }, children);
};
VacIdProvider.displayName = "VacIdProvider";

// ../internal/src/hooks/use-chat-instance-state.tsx
import React3 from "react";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";

// ../internal/src/providers/attachment-provider/attachment-provider.tsx
var defaults = {
  attachmentConfig: {}
};
var AttachmentContext = React4.createContext(defaults);
var AttachmentProvider = props => {
  const {
    children,
    attachmentConfig
  } = props;
  return /* @__PURE__ */React4.createElement(AttachmentContext.Provider, {
    value: {
      attachmentConfig
    }
  }, children);
};
AttachmentProvider.displayName = "AttachmentProvider";

// ../internal/src/providers/timer/timer-provider.tsx
import React5 from "react";

// ../internal/src/providers/timer/constants.ts
var constants_exports = {};
__export(constants_exports, {
  CHAT_MOUNTED: () => CHAT_MOUNTED,
  CHAT_TRANSCRIPT: () => CHAT_TRANSCRIPT,
  CREATE_CONVERSATION: () => CREATE_CONVERSATION,
  CREATE_CONVERSATION_INIT: () => CREATE_CONVERSATION_INIT,
  DEFAULT: () => DEFAULT,
  INIT: () => INIT,
  SEND_CONVERSATION_EVENT: () => SEND_CONVERSATION_EVENT,
  SEND_FILE_MESSAGE: () => SEND_FILE_MESSAGE,
  SEND_MESSAGE: () => SEND_MESSAGE,
  TRIGGER_CLICKED: () => TRIGGER_CLICKED,
  TRIGGER_MOUNTED: () => TRIGGER_MOUNTED
});
var INIT = "orchestrator-init";
var CHAT_MOUNTED = "chat-mounted";
var TRIGGER_MOUNTED = "trigger-mounted";
var TRIGGER_CLICKED = "trigger-clicked";
var CREATE_CONVERSATION = "create-conversation";
var CREATE_CONVERSATION_INIT = "create-conversation-init";
var CHAT_TRANSCRIPT = "chat-transcript";
var SEND_CONVERSATION_EVENT = "send-conversation-event";
var SEND_MESSAGE = "send-message";
var SEND_FILE_MESSAGE = "send-file-message";
var DEFAULT = {
  startTimer: id => null,
  getTime: id => -1
};

// ../internal/src/providers/timer/timer-provider.tsx
var Context = React5.createContext(DEFAULT);
var TimerProvider = ({
  children
}) => {
  const timers = React5.useRef({});
  const startTimer = id => {
    if (timers.current[id]) {
      return;
    }
    timers.current[id] = Date.now();
  };
  const getTime = (id, resetTimer = false) => {
    if (!timers.current[id]) {
      return -1;
    }
    const timerTimestamp = timers.current[id];
    if (resetTimer) {
      delete timers.current[id];
    }
    return Date.now() - timerTimestamp;
  };
  const value = React5.useMemo(() => ({
    startTimer,
    getTime
  }), [startTimer, getTime, timers]);
  return /* @__PURE__ */React5.createElement(Context.Provider, {
    value
  }, children);
};
TimerProvider.displayName = "TimerProvider";
var useTimers = () => {
  const timers = React5.useContext(Context);
  return timers;
};
var withTimers = WrappedComponent => {
  const Wrapper = props => {
    return /* @__PURE__ */React5.createElement(TimerProvider, null, /* @__PURE__ */React5.createElement(WrappedComponent, {
      ...props
    }));
  };
  Wrapper.displayName = "withTimers";
  return Wrapper;
};
export { AttachmentProvider, constants_exports as TIMERS, TimerProvider, useTimers, withTimers };
/* istanbul ignore file -- @preserve */
//# sourceMappingURL=index.js.map